import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, share, timeout } from 'rxjs';
import { environment } from '@env/environment';
import { IAuthUser } from '../interfaces/auth-user.interface';
import { cacheContext, ECacheTTL } from 'ngx-mt-ui-lib/cache';

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  private readonly httpClient = inject(HttpClient);
  /**
   * Получение данны авторизованного пользователя
   */
  public getCurrentUserInfo(): Observable<IAuthUser> {
    return this.httpClient
      .get<IAuthUser>(`${environment.API_URL}/user/profile`, {
        context: cacheContext({ ttl: ECacheTTL.MINUTE * 5 }),
      })
      .pipe(timeout(30_000), share());
  }

  /**
   * Профиль пользователя. Список айди доступных пользователю ролей реагирования
   */
  public getUserReactRoles(): Observable<number[]> {
    return this.httpClient
      .get<number[]>(`${environment.API_URL}/user/profile/react-role/list`, {
        context: cacheContext({ ttl: ECacheTTL.MINUTE * 5 }),
      })
      .pipe(share());
  }
}
